<script>
import { mapState } from 'vuex'
import { render } from '@/common/util/templateCompiler'

/**
 * This component is responsible for rendering additional CardForm, creating
 * the formId, adding Vuex namespace, etc...
 *
 * Render function content is based on cardFormBlueprint created by
 * FormRenderer.createBluePrint.
 *
 * @since KJS-4782
 */
export default {
  name: 'KryptonCardFormSpawnPoint',
  props: {
    section: {
      type: String,
      required: true,
      validator: value => ['modal', 'ILLICADO'].includes(value)
    }
  },
  data() {
    return {
      formId: null
    }
  },
  computed: {
    ...mapState(['cardFormBlueprint']),
    /**
     * __formId__ is set in blueprint by FormRenderer.createBlueprint
     */
    html() {
      if (!this.formId || !this.cardFormBlueprint) return ''
      return this.cardFormBlueprint.replace(/__formId__/g, this.formId)
    },
    ready() {
      return (
        !!this.formId &&
        this.html.length > 0 &&
        this.$store.hasModule(`cardForm_${this.formId}`)
      )
    }
  },
  mounted() {
    this.spawn()
  },
  methods: {
    spawn() {
      this.formId = this.$locator.cardFormController.createForm(this.section)
    }
  },
  render($createElement) {
    if (!this.ready) {
      // If for any reason whatsoever we are unable to render card form,
      // render a generic & invisible div
      return $createElement('div', {
        class: { 'kr-card-form-spawn-point': true },
        style: { display: 'none' }
      })
    }
    const domParser = new DOMParser()
    const document = domParser.parseFromString(this.html, 'text/html')
    return render(this, $createElement, document.body.firstChild)
  }
}
</script>
